import React from 'react';
import { string } from 'prop-types';
import loader from '../../assets/images/loader.svg';

const CircularProgress = ({ className = '' }) => (
  <div className={`loader ${className}`}>
    <img src={loader} alt="loader" />
    <h6 className="gx-mt-3">Loading...</h6>
  </div>
);

CircularProgress.propTypes = { className: string };

export default CircularProgress;
